import './template-product.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const initProductGallery = (gallery) => {
    const swiperGallery = new Swiper(gallery.querySelector('.product-gallery__container'));
    templateProductSection.querySelectorAll('.product-thumbnails-grid .grid-thumbnail').forEach(thumbnail => {
      const thumbnailIndex = thumbnail.dataset.thumbnailIndex;
      thumbnail.addEventListener('click', () => {
        templateProductSection.querySelectorAll('.product-thumbnails-grid .grid-thumbnail').forEach(sibling => {
          sibling.classList.remove('active')
        });
        thumbnail.classList.add('active');
        swiperGallery.slideTo(thumbnailIndex - 1);
      });
    });
  }

  const productsGalleries = templateProductSection.querySelectorAll('.product-gallery');
  productsGalleries.forEach(productsGallery => {
    new Swiper(productsGallery.querySelector('.product-gallery__container'), {
      loop: true,
      direction: 'horizontal',
      pagination: {
        el: productsGallery.querySelector('.product-gallery__pagination'),
        type: productsGallery.dataset.paginationType,
        clickable: true
      },
      navigation: {
        prevEl: productsGallery.querySelector('.product-gallery__arrow--left'),
        nextEl: productsGallery.querySelector('.product-gallery__arrow--right')
      },
      breakpoints: {
        1024: {
          loop: false,
          allowSlidePrev: productsGallery.classList.contains('product-gallery--scroll') ? false : true,
          allowSlideNext: productsGallery.classList.contains('product-gallery--scroll') ? false : true
        }
      }
    });

    initProductGallery(productsGallery);
  });

  const productMeta = templateProductSection.querySelector('.product__meta');
  const productForm = templateProductSection.querySelector('.product__form');
  productForm.querySelectorAll('.product__form__option__toggle').forEach(toggle => {
    const fieldset = toggle.closest('fieldset');
    if (!fieldset) return;
    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('checked')) return;
      const checkedLabels = fieldset.querySelectorAll('label[checked]');
      checkedLabels.forEach(label => { label.removeAttribute('checked') });
      toggle.setAttribute('checked', '');
    });
  });

  const colorsAccordion = productForm.querySelector('.product__form__colors-accordion');
  if (colorsAccordion) {
    const accordionHeader = colorsAccordion.querySelector('.product__form__colors-accordion__header');
    const accordionContent = colorsAccordion.querySelector('.product__form__colors-accordion__content');
    if (accordionHeader && accordionContent) {
      var isMoving = false;
      accordionHeader.addEventListener('click', function () {
        if (isMoving) return;
        isMoving = true;
        if (colorsAccordion.getAttribute('open')) {
          $(accordionContent).slideUp(350, function () {
            isMoving = false;
            colorsAccordion.removeAttribute('open');
            this.style.display = '';
          });
        } else {
          $(accordionContent).slideDown(350, function () {
            isMoving = false;
            colorsAccordion.setAttribute('open', 'true');
            this.style.display = '';
          });
        }
      });

      const colorToggles = accordionContent.querySelectorAll('.color-label');
      if (colorToggles.length > 0) {
        colorToggles.forEach(toggle => {
          const colorValue = toggle.closest('.color-label').dataset.colorValue;
          const summaryColor = accordionHeader.querySelector('.color-label');
          if (colorValue && summaryColor) {
            toggle.addEventListener('click', () => {
              summaryColor.innerText = colorValue;
              summaryColor.dataset.colorValue = colorValue;
            });
          }
        });
      }
    }
  }

  const saleTag = productMeta.querySelector('.product__meta__price__discount');
  $(context).on('variantChange', e => {
    if (!e || !e.variant) return;
    
    if (e.variant.price && e.variant.compare_at_price && e.variant.price != e.variant.compare_at_price && saleTag) {
      let discount = ((e.variant.compare_at_price - e.variant.price) / e.variant.compare_at_price) * 100;
      discount = parseInt(discount);
      saleTag.textContent = `-${discount}%`
      saleTag.classList.add('active');
    } else {
      saleTag.classList.remove('active')
    }

    const selectedOption = productForm.querySelector(`select[name="id"] option[value="${e.variant.id}"][data-stock]`);
    if (!selectedOption) return;
  });

  $('.product-template').on('variantSKUChange', function (e) {
    const active = this.querySelector('.product-gallery[active]');
    if (active) {
      active.removeAttribute('active');
    }

    const galleries = this.querySelectorAll('.product-gallery');
    for (let i = 0; i < galleries.length; i++) {
      const gallery = galleries[i];
      if (gallery.getAttribute("data-sku") == e.variant.sku) {
        gallery.setAttribute('active', true);
        initProductGallery(gallery);
      }
    }
  })
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
